import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=ea0aeefa&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea0aeefa')) {
      api.createRecord('ea0aeefa', component.options)
    } else {
      api.reload('ea0aeefa', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=ea0aeefa&", function () {
      api.rerender('ea0aeefa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NMV1k2jn78Dy/JS/comp/IncreaseNumber.vue"
export default component.exports